export const macOS = () => navigator.userAgent.includes("Mac");
